import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';
import { useMessages } from './utils/use-messages';
export var LazyMessagesProvider = function LazyMessagesProvider(props) {
  var intl = useIntl();
  var messages = useMessages(intl.locale);
  return /*#__PURE__*/React.createElement(IntlProvider, _extends({}, props, {
    defaultLocale: "en",
    messages: messages,
    locale: intl.locale
  }));
};